import { findOptions, getDivergenceOrEqual } from "../../../helpers/StringHelper";

export const mapPrograms = (data, options = {}) => {
  const {
    countries: countryOptions,
    programPartnerStatus,
    minerals,
    isChild,
  } = options || {};

  return data.map((program, i) => {
    const location = program.location || {};
    const author = program.author ? (program.author.name ? program.author.name : `${program.author.firstName} ${program.author.lastName}`) : '';
    const childrens = (program.children || []);

    const countries = (program?.amps || []).reduce((all, _val) => {
      const val = program?.linking?.AMPS[_val.id];

      if (val && val.country && !all.includes(val.country)) {
        all.push(val.country);
      }

      return all;
    }, []);
    program = program || {};

    const config = {
      id: program ? program.datastakeId : '',
      dbId: options.isChild ? `${program.id}-${i}` : program.id,
      author,
      mainMineralProduced: program?.mainMineralProduced ? findOptions(program.mainMineralProduced, minerals) : null,
      otherMineralProduced: (program?.otherMineralProduced || []).map((v) => findOptions(v, minerals)),
      name: program?.name,
      amps: (program?.amps || []).map((v) => program?.linking?.AMPS[v.id]).filter((v) => !!v),
      category: program.category,
      products: (program?.products || []).map((p) => findOptions(p, minerals)),
      sources: program.sources || [],
      country: countries.map((c) => findOptions(c, countryOptions)),
      location: location.locationName || '-',
      pmeProject: program?.pmeProject,
      version: program?.version,
      authorId: program.authorId ? program.authorId : undefined,
      status: {
        value: program.status,
        label: findOptions(program.status, programPartnerStatus),
      },
      isChild,
      updatedAt: program.updatedAt,
      publishedAt: program.publishedAt,
    };

    if (childrens.length > 1) {
      Object.assign(config, {
        children: mapPrograms(childrens, { ...options, isChild: true }),
      });
      config.sourcesLen = config.children.length;
    }

    return getDivergenceOrEqual(config, ['province', 'territory']);
  });
}

export const getProgramFilterOptions = (options) => {
  const {
    countries = [],
    programPartnerStatus = [],
    minerals = [],
  } = options || {};

  return {
    country: countries,
    location: [],
    operator: [],
    products: minerals,
    status: programPartnerStatus,
  }
}

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const selectFiltersConfig = {
  country: {
    type: 'select',
    label: 'Country',
    placeholder: (t) => `${t('Filter by')} ${t('Country').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  products: {
    type: 'select',
    isMulti: true,
    label: 'Product(s)',
    placeholder: (t) => `${t('Filter by')} ${t('Product(s)').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  status: {
    type: 'select',
    label: 'Status',
    placeholder: (t) => `${t('Filter by')} ${t('Status').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};
